<app-dashboard [filter]='filter | async' [savedFilterName]='filterName'></app-dashboard>
